<template>
    <div class="container-fluid" :class="{'loading': loading}">
        <div class="row">
            <form @submit.prevent="updateUser" action="#" class="register-form mb-4 w-100">

                <h3 class="lead">{{ $t('Account') }}</h3>
                <div class="row">
                    <div class="form-group col-sm-6">
                        <input v-model="editUserForm.first_name" type="text" name="first_name" :placeholder="$t('First name') + '*'" class="form-control" :class="{ 'is-invalid': errors && errors.first_name }">
                        <div class="alert alert-danger" v-if="errors && errors.first_name">
                            {{ errors.first_name[0] }}
                        </div>
                    </div>

                    <div class="form-group col-sm-6">
                        <input v-model="editUserForm.last_name" type="text" name="last_name" :placeholder="$t('Last name') + '*'"
                               class="form-control" :class="{ 'is-invalid': errors && errors.last_name }">
                        <div class="alert alert-danger" v-if="errors && errors.last_name">
                            {{ errors.last_name[0] }}
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="form-group col-sm-6">
                        <input v-model="editUserForm.phone" type="text" name="phone" :placeholder="$t('Phone') + '*'"
                               class="form-control" :class="{ 'is-invalid': errors && errors.phone }">
                        <div class="alert alert-danger" v-if="errors && errors.phone">
                            {{ errors.phone[0] }}
                        </div>
                    </div>

                    <div class="form-group col-sm-6">
                        <input v-model="editUserForm.email" type="text" name="email" :placeholder="$t('E-mail') + '*'"
                               class="form-control" :class="{ 'is-invalid': errors && errors.email }">
                        <div class="alert alert-danger" v-if="errors && errors.email">
                            {{ errors.email[0] }}
                        </div>
                    </div>
                </div>

                <h3 class="lead">{{ $t('Company') }}</h3>

                <div class="row">
                    <div class="form-group col-sm-6">
                        <input v-model="editUserForm.name" type="text" name="name" :placeholder="$t('Company') + '*'" class="form-control" :class="{ 'is-invalid': errors && errors.name }">
                        <div class="alert alert-danger" v-if="errors && errors.name">
                            {{ errors.name[0] }}
                        </div>
                    </div>
                    <div class="form-group col-sm-6">
                        <input v-model="editUserForm.ustid" type="text" name="name" :placeholder="$t('VAT no.')" class="form-control" :class="{ 'is-invalid': errors && errors.ustid }">
                        <div class="alert alert-danger" v-if="errors && errors.ustid">
                            {{ errors.ustid[0] }}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-sm-12">
                        <input v-model="editUserForm.street" type="text" name="street" :placeholder="$t('Street') + '*'" class="form-control" :class="{ 'is-invalid': errors && errors.street }">
                        <div class="alert alert-danger" v-if="errors && errors.street">
                            {{ errors.street[0] }}
                        </div>
                    </div>
                    <div class="form-group col-sm-6">
                        <input v-model="editUserForm.zip_code" type="text" name="zip_code" :placeholder="$t('ZIP code')" class="form-control" :class="{ 'is-invalid': errors && errors.zip_code }">
                        <div class="alert alert-danger" v-if="errors && errors.zip_code">
                            {{ errors.zip_code[0] }}
                        </div>
                    </div>
                    <div class="form-group col-sm-6">
                        <input v-model="editUserForm.city" type="text" name="city" :placeholder="$t('City') + '*'" class="form-control" :class="{ 'is-invalid': errors && errors.city }">
                        <div class="alert alert-danger" v-if="errors && errors.city">
                            {{ errors.city[0] }}
                        </div>
                    </div>
                    <div class="form-group col-sm-6">
                        <input v-model="editUserForm.country" type="text" name="country" :placeholder="$t('Country') + '*'" class="form-control" :class="{ 'is-invalid': errors && errors.country }">
                        <div class="alert alert-danger" v-if="errors && errors.country">
                            {{ errors.country[0] }}
                        </div>
                    </div>
                </div>
                <h3 class="lead" v-if="$can('edit_discounts')">{{ $t('Customer discount') }}</h3>
                <div class="row" v-if="$can('edit_discounts')">
                    <div class="form-group col-sm-6">
                        <input v-model="editUserForm.user_project_discount" type="number" step="0.1" name="name" :placeholder="$t('Customer discount')" class="form-control" @focus="userDiscountChangeWarning" :class="{ 'is-invalid': errors && errors.user_project_discount }">
                        <div class="alert alert-danger" v-if="errors && errors.user_project_discount">
                            {{ errors.user_project_discount[0] }}
                        </div>
                    </div>
                </div>
                <div class="row" v-if="$can('can_change_purchase_price_setting')">
                    <div class="form-group col-sm-6">
                        <div class="form-check">
                            <input type="checkbox" class="form-check-input" id="viewPurchasePrices" :class="{ 'is-invalid': errors && errors.view_purchase_prices }" v-model="editUserForm.view_purchase_prices">
                            <label class="form-check-label" for="viewPurchasePrices">{{ $t('Display purchase prices') }}</label>
                        </div>
                        <div class="alert alert-danger" v-if="errors && errors.view_purchase_prices">
                            {{ errors.view_purchase_prices[0] }}
                        </div>
                    </div>
                </div>
                <div class="row" v-if="$can('can_change_ic_price_setting')">
                    <div class="form-group col-sm-6">
                        <div class="form-check">
                            <input type="checkbox" class="form-check-input" id="viewIcPrices" :class="{ 'is-invalid': errors && errors.view_ic_prices }" v-model="editUserForm.view_ic_prices">
                            <label class="form-check-label" for="viewIcPrices">{{ $t('Display IC prices') }}</label>
                        </div>
                        <div class="alert alert-danger" v-if="errors && errors.view_ic_prices">
                            {{ errors.view_ic_prices[0] }}
                        </div>
                    </div>
                </div>

                <button type="submit" class="btn btn-primary" :disabled="editUserFormSubmitting">{{ $t('Save') }}</button>
                <button class="btn text-light" @click="cancelEdit" :disabled="editUserFormSubmitting" v-if="$route.fullPath.includes('benutzer/')">
                    {{ $t('Cancel') }}</button>
            </form>
            <button class="btn btn-outline-danger mt-5" @click.prevent="deleteUser(editUserForm.id)" :disabled="userDeleting"><i class="far fa-trash-alt" :title="$t('Delete')"></i>
                {{ $t('Delete account and associated data') }}</button>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
    data() {
        return {
            loading: false,
            editUserForm: {
                id: '',
                name: '',
                email: '',
                first_name: '',
                last_name: '',
                phone: '',
                street: '',
                zip_code: '',
                city: '',
                country: '',
                ustid: '',
                user_project_discount: '',
            },
            errors: [],
            editUserFormSubmitting: false,
            userDeleting: false,
            discountWarningCounter: 0,
        }
    },

    mounted() {
        this.prefillForm();

    },

    methods: {
        ...mapActions({
            updateLoginStatus: 'auth/me',
            signOutAction: 'auth/signOut'
        }),


        async signOut () {
            await this.signOutAction()
            if (this.$route.name !== 'home') {
                this.$router.push({ name: 'home' });
            }
        },


        prefillForm() {
            if (this.$route.fullPath.includes('account')) {
                this.editUserForm.name = this.user.name;
                this.editUserForm.email = this.user.email;
                this.editUserForm.id = this.user.id;
                this.editUserForm.first_name = this.user.first_name;
                this.editUserForm.last_name = this.user.last_name;
                this.editUserForm.phone = this.user.phone;
                this.editUserForm.street = this.user.street;
                this.editUserForm.zip_code = this.user.zip_code;
                this.editUserForm.city = this.user.city;
                this.editUserForm.country = this.user.country;
                this.editUserForm.ustid = this.user.ustid;

                if(this.$can('can_change_purchase_price_setting') && this.user.user_permissions && this.user.user_permissions.includes('view_purchase_prices')) {
                    this.editUserForm.view_purchase_prices = true;
                }

                if(this.$can('can_change_ic_price_setting') && this.user.user_permissions && this.user.user_permissions.includes('view_ic_prices')) {
                    this.editUserForm.view_ic_prices = true;
                }

                if (this.$can('edit_discounts')) {
                    this.editUserForm.user_project_discount = this.user.user_project_discount;
                }
            } else {
                this.getUser();
            }


        },

        getUser() {
            this.loading = true;
            axios.get('/api/users/' + this.$route.params.id)
                .then(response => {
                    this.editUserForm = response.data.data;
                    this.loading = false;

                if(this.$can('can_change_purchase_price_setting') && this.editUserForm.user_permissions && this.editUserForm.user_permissions.includes('view_purchase_prices')) {
                    this.editUserForm.view_purchase_prices = true;
                }

                if(this.$can('can_change_ic_price_setting') && this.editUserForm.user_permissions && this.editUserForm.user_permissions.includes('view_ic_prices')) {
                    this.editUserForm.view_ic_prices = true;
                }

                }).catch(error => {
                this.loading = false;
            });
        },

        userDiscountChangeWarning() {
            if (this.discountWarningCounter < 1) {
                this.$swal.fire({
                    icon: 'info',
                    title: this.$t('Change of discount'),
                    text: this.$t('By changing the discount, all prices are recalculated (except for projects requested or ordered).'),
                    confirmButtonColor: '#3CA2A4'
                });
            }
            this.discountWarningCounter++;
        },

        updateUser() {
            this.editUserFormSubmitting = true;
            this.loading = true;
            axios.put('/api/users', this.editUserForm)
                .then(response => {
                    console.log('user updated');
                    this.updateLoginStatus();
                    this.editUserFormSubmitting = false;
                    this.loading = false;
                    this.$emit('formSubmitted', true);
                    this.$swal.fire({
                        icon: 'success',
                        title: this.$t('Saved successfully'),
                        confirmButtonColor: '#3CA2A4'
                    });
                }).catch( error => {
                    if (error.response.status === 422) { // Validation Error
                        this.errors = error.response.data.errors;
                    }
                    this.editUserFormSubmitting = false;
                    this.loading = false;
                    this.$swal.fire({icon: 'error', title: this.$t('There was an error'), confirmButtonColor: '#3CA2A4'});
                }
            );
        },

        cancelEdit(event) {
            this.$emit('clicked', true);
        },

        deleteUser(user_id) {
            this.$swal.fire({
                title: this.$t('Delete account?'),
                text: this.$t('After deleting the account, associated projects can not be restored.'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#e3342f',
                cancelButtonColor: '#393e42',
                confirmButtonText: this.$t('Yes, delete!'),
                cancelButtonText: this.$t('Cancel')
            }).then((result) => {
                if (result.value) {
                    this.userDeleting = true;
                    this.loading = true;
                    axios.delete('/api/users/' + user_id)
                        .then(response => {
                            this.$swal.fire({
                                icon: 'success',
                                title: this.$t('Deleted successfully')
                            });
                            this.userDeleting = false;
                            this.loading = false;
                            this.signOut();
                        }).catch(error => {
                        this.$swal.fire({
                            icon: 'error',
                            title: this.$t('There was an error')
                        });
                        this.userDeleting = false;
                        this.loading = false;
                    });

                }
            })
        },

    },

    computed: {
        ...mapGetters({
            authenticated: 'auth/authenticated',
            user: 'auth/user',
            permissions: 'auth/permissions'
        }),
    },
}
</script>
